import TENDER_FORM_DATA from '@/utils/constants/tender';
import CreateModal from '@/containers/tenders/CreateModal';
import { mapActions, mapMutations, mapState } from 'vuex';
import teamQuery from '@/gql/projects/team.graphql';

const createTender = {
  data() {
    return {
      teamSettingsFilled: true,
    };
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('global', ['currentProject']),
    ...mapState('project', ['projectInfo']),
  },
  methods: {
    ...mapMutations({
      setTender: 'tenderEdit/setTender',
    }),
    ...mapActions({
      openModal: 'modal/openModal',
      confirm: 'confirmModal/openModal',
      loadProjectInfo: 'project/loadProjectInfo',
    }),
    async checkTeamSettings() {
      const { data } = await this.$apollo.query({
        query: teamQuery,
        variables: {
          id: this.user?.membership?.id,
        },
      });

      this.teamSettingsFilled = !!(data.team[0]?.name && data.team[0]?.registration_number);
    },
    async checkProjectInfo() {
      if (!this.projectInfo) {
        await this.loadProjectInfo({ id: this.currentProject.id });
      }
    },
    async createTender(tenderPreset = {}) {
      await this.checkTeamSettings();
      await this.checkProjectInfo();

      if (this.teamSettingsFilled) {
        this.setTender(
          Object.assign(
            {},
            {
              ...TENDER_FORM_DATA,
              address: this.currentProject.address,
              contact_person_responsible_user_id: this.user?.id,
              ...tenderPreset,
            }
          )
        );

        this.openModal({
          component: CreateModal,
          context: {
            team: this.currentProject.team,
            attributes: {
              class: ['create-tender__container'],
            },
            nonclosable: true,
          },
        });
      } else {
        this.confirm({
          title: this.$t('Fill in the required fields before creating a tender'),
          actionText: this.$t('Go to Company settings'),
          description: this.$t(
            'These changes can be made by the administrator in the "Company settings" section'
          ),
          action: () => {
            this.$router.push({
              query: {
                modal: 'teamSettings',
                tab: 'settings',
              },
            });
          },
        });
      }
    },
  },
};

export default createTender;
